import routes from 'src/config/api.routes';
import axiosService from './axiosService';

class AccountService {
  UpdateAccount = async (accountDto) => axiosService.put(`${routes.account}/profile`, accountDto);
}

const accountService = new AccountService();
export default accountService;
